import type { ZodInfer } from '@mntn-dev/utility-types'
import { EnumBuilder } from '@mntn-dev/utility-types'

export const [PaymentGateways, PaymentGatewaySchema, PaymentGatewayMap] =
  EnumBuilder('Tipalti', 'Stripe')

export type PaymentGateway = ZodInfer<typeof PaymentGatewaySchema>

export const PaymentGateway = (input: string): PaymentGateway => {
  return PaymentGatewaySchema.parse(input)
}
